import React from 'react';
import { Token } from '@amzn/awsui-components-react/polaris/property-filter/interfaces';
import { KatIcon } from '@amzn/katal-react';
import { useTranslation } from 'src/i18next-arb-shim/useTranslation';
import { Tag } from 'src/components/common/ui/Tags/Tags';
import styles from 'src/components/common/ui/Tags/Tags.module.scss';
import { CompletedReviewsTableColumn } from './CompletedReviewsColumnConfig';

type Props = {
  id: string;
  appliedFilters: Token[];
  onTagRemove: (e: React.MouseEvent, tag: Tag) => void;
};

/**
 * Completed Reviews Table Filter Tag
 *
 * Displays applied filters as removable tags with property labels.
 */
const CompletedReviewsTableFilterTag: React.FC<Props> = ({
  id,
  appliedFilters,
  onTagRemove,
}) => {
  const { t } = useTranslation();

  // Convert filter tokens to tags with property labels
  const tags: Tag[] = appliedFilters.map((token) => {
    const column = Object.values(CompletedReviewsTableColumn).find(
      (col) =>
        col.property ===
        (token.propertyKey ||
          CompletedReviewsTableColumn.MESSAGE_GROUP.property)
    );
    return {
      field: column?.translationKey || '',
      id: token.propertyKey || '',
      name: token.value,
    };
  });

  // Render tags with property label and close icon
  const tagList = tags.map((tag, idx) => (
    <div
      id={`${id}-${idx}`}
      key={`${tag.id}-${tag.name}`}
      className={styles.tag}
    >
      {/* Display property name and filter value */}
      <span className={styles.label}>
        <b>{t(tag.field)}: </b>
        {tag.name}
      </span>
      {/* Close icon to remove tag */}
      <span className={styles.close} onClick={(e) => onTagRemove(e, tag)}>
        <KatIcon name="close" size="small" className={styles.icon} />
      </span>
    </div>
  ));

  return (
    <div id={id} className={styles.tags}>
      {tagList}
    </div>
  );
};

export default CompletedReviewsTableFilterTag;
